import React from 'react';

import {
  Actions as ActionsUI,
  Action,
  ContentCopyIcon,
  EditSellOutlinedIcon,
  OpenInNewIcon,
} from '@gogame/components';

const Actions = ({ limit = 3, color, onCopyName, onOpen, onEdit }) => {
  return (
    <ActionsUI limit={limit} color={color}>
      <Action
        id={'copy_name'}
        icon={<ContentCopyIcon />}
        label={'Copy name'}
        onClick={onCopyName}
      />
      <Action
        id={'open'}
        icon={<OpenInNewIcon />}
        label={'Open'}
        onClick={onOpen}
      />
      <Action
        id={'edit'}
        icon={<EditSellOutlinedIcon />}
        label={'Edit tags'}
        onClick={onEdit}
      />
    </ActionsUI>
  );
};

export default Actions;
